<div class="edp-modal-iframe" [ngClass]="{'animate': slideUp}">
    <div class="edp-modal-iframe-header">
        <button type="button" class="btn btn-link edp-color-neu-07"
            (click)="close()">{{ 'pt.edp.edponline.payment.button.close' | translate }}</button>
    </div>
    <div class="edp-modal-iframe-wrapper" [ngClass]="{ ios: isIOS }">
        <iframe #iframe *ngIf="!params.isFile" [src]="safeUrl" height="100%" width="100%" title="" frameborder="0"
            [ngClass]="{ ios: isIOS }"></iframe>
        <pdf-viewer *ngIf="params.isFile" [src]="params.url" [fit-to-page]="true" (error)="onError($event)"></pdf-viewer>
    </div>
</div>